/* IvitaPure — Crealyte PDP: klippen i "Så gör du".

   Klippen spelas EN gång och stannar sedan på sista rutan. Tre loopar bredvid
   varandra, ur takt med varandra, ger ständig rörelse i ögonvrån och gör sidan
   stressig. En genomspelning visar samma sak utan att aldrig ta slut, och
   knappen i hörnet finns för den som vill se om.

   Två olika beteenden, av samma skäl — bara ett klipp ska röra sig åt gången:

   • Dator: stegen står bredvid varandra, så de spelas som en kedja. Första
     startar när sektionen syns, nästa när den föregående tagit slut. Steget
     som spelas markeras, så blicken följer med genom 1 → 2 → 3.
   • Mobil: stegen ligger i en svepkarusell där bara ett syns i taget. Där
     startar klippet i stället när man sveper fram det.

   Dessutom: har besökaren bett om mindre rörelse i systemet startar ingenting
   av sig självt, affischbilden står kvar och knappen syns direkt. Klippen
   laddas först när de behövs, och nekas autospel visas knappen i stället.
*/
(function () {
  var klipp = [].slice.call(document.querySelectorAll('[data-cpdp-step-video]'));
  if (!klipp.length) return;

  var lista = klipp[0].closest('.cpdp-steps-list');
  var steg = klipp.map(function (v) { return v.closest('.cpdp-step'); });

  var stillaFraga = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var bredFraga = window.matchMedia ? window.matchMedia('(min-width: 700px)') : null;
  function stilla() { return !!(stillaFraga && stillaFraga.matches); }
  function kedja() { return !!(bredFraga && bredFraga.matches); }

  function knapp(v) {
    var f = v.parentElement;
    return f ? f.querySelector('[data-cpdp-step-replay]') : null;
  }
  function visaKnapp(v, visa) {
    var k = knapp(v);
    if (k) k.hidden = !visa;
  }

  function stapel(v) {
    var f = v.parentElement;
    var s = f ? f.querySelector('[data-cpdp-step-progress]') : null;
    return s ? s.firstElementChild : null;
  }

  function markera(i) {
    if (lista) lista.classList.add('har-spelat');
    steg.forEach(function (s, n) {
      if (s) s.classList.toggle('is-aktiv', n === i);
    });
    /* Nollställ linjerna på de steg som inte spelar, så bara ett fylls i taget. */
    klipp.forEach(function (v, n) {
      var b = stapel(v);
      if (b && n !== i) b.style.width = '0';
    });
  }

  function spela(i) {
    var v = klipp[i];
    if (!v) return;
    /* Bara ett klipp i taget. De andra pausas och får sin knapp, så den som vill
       hoppa direkt till ett senare steg kan göra det utan att två rullar samtidigt. */
    klipp.forEach(function (annan, n) {
      if (n === i) return;
      try { annan.pause(); } catch (e) { /* ignorera */ }
      visaKnapp(annan, true);
    });
    visaKnapp(v, false);
    markera(i);
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () { visaKnapp(v, true); });
  }

  /* Knapparna ligger synliga i markupen och blir kvar på de klipp som inte spelar:
     dels går det alltid att starta ett klipp även om skriptet inte kör, dels kan
     man hoppa fram till ett senare steg utan att vänta ut kedjan. */
  klipp.forEach(function (v, i) {
    v.addEventListener('timeupdate', function () {
      var b = stapel(v);
      if (!b || !isFinite(v.duration) || !v.duration) return;
      b.style.width = Math.min(100, (v.currentTime / v.duration) * 100) + '%';
    });
    v.addEventListener('ended', function () {
      visaKnapp(v, true);
      /* På datorn tar nästa steg vid direkt, så sekvensen läses som en helhet. */
      if (kedja() && klipp[i + 1]) spela(i + 1);
    });
    var k = knapp(v);
    if (k) k.addEventListener('click', function () {
      v.currentTime = 0;
      spela(i);
    });
    if (stilla()) visaKnapp(v, true);
  });

  if (stilla()) return;

  if (!('IntersectionObserver' in window)) {
    spela(0);
    return;
  }

  /* Datorkedjan: starta första klippet en gång, när sektionen kommit i vy. */
  if (lista) {
    var startad = false;
    var listVakt = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting || startad || !kedja()) return;
        startad = true;
        listVakt.unobserve(p.target);
        spela(0);
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0.2 });
    listVakt.observe(lista);
  }

  /* Mobilkarusellen: klippet startar när man sveper fram det. Vi startar bara
     vid övergången dold → synlig, annars skulle den spelas om av minsta skutt. */
  var varSynlig = [];
  var kortVakt = new IntersectionObserver(function (poster) {
    poster.forEach(function (p) {
      var i = klipp.indexOf(p.target);
      if (i < 0) return;
      var forr = varSynlig[i] || false;
      varSynlig[i] = p.isIntersecting;
      if (kedja() || !p.isIntersecting || forr) return;
      spela(i);
    });
  }, { threshold: 0.6 });

  klipp.forEach(function (v) { kortVakt.observe(v); });
})();
